import { useState, useEffect } from "react";

const LIST_ORDERBY = [
  { label: `Recently Added`, type: `default`, bp: `` },
  { label: `Release Date`, type: `release`, bp: `publish_date` },
  { label: `A-Z`, type: `title`, bp: `name` },
  { label: `Label`, type: `label`, bp: `label` },
  { label: `Genre`, type: `genre_s`, bp: `genre` },
  { label: `BPM`, type: `bpm`, bp: `` },
  { label: `Key`, type: `key_camelot`, bp: `` },
  { label: `Artists`, type: `artists_s`, bp: `` },
  { label: `Mix Name`, type: `mix_name`, bp: `mix_name` },
  { label: `Remixers`, type: `remixers_s`, bp: `` },
  { label: `Top`, type: `top`, bp: `` },
]

const useOrderBy = (list, id) => {

  const applyOrderBy = (index) => () => {
    prepareSetOrderBy(index);
  }

  const prepareList = list.map( (type, i) => ({ ...LIST_ORDERBY.find( o => o.type === type ), asc: null, active: (type === `default`), onClick: applyOrderBy(i) }) )
  const [ orderBy, setOrderByHook ] = useState(prepareList);
  const [ idParent ] = useState(id);

  useEffect(() => {
    if (list.length > 0 && id !== idParent) {
      setOrderByHook(prepareList);
    }  else if (list.length === 0 && id !== idParent) {
      setOrderByHook(prepareList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])

  const getOrderByFormatted = () => {
    const ob = orderBy.find(x => x.active);
    return (ob && ob.type !== `default`) ? `&order_by=${(!ob.asc) ? `-` : ``}${ob.bp}` : '';
  }

  const prepareSetOrderBy = (index) => {
    setOrderByHook(orderBy.map( (x,i) => {
      if (index === i) {
        x.asc = (x.asc === null) ? true : (x.asc ? false : null); // asc / desc / null
        x.active = (index === i && x.asc !== null);
      } else {
        x.active = false;
        x.asc = null;
      }
      return x;
    } ))
  };

  const sortLocalData = (data) => {
    let result = [...data];
    const ob = orderBy.find(x => x.active);
    if (ob && data) {
      result.sort((a, b) => {
        if (ob.type === 'default') {
          return 0
        } else if (ob.type === 'key_camelot') {
          const aNumber = parseInt(a[ob.type].slice(0, -1));
          const bNumber = parseInt(b[ob.type].slice(0, -1));
          if (aNumber < bNumber) { return (ob.asc) ? -1 : 1 }
          if (aNumber > bNumber) { return (ob.asc) ? 1 : -1 }
        } else {
          if (a[ob.type] < b[ob.type]) { return (ob.asc) ? -1 : 1 }
          if (a[ob.type] > b[ob.type]) { return (ob.asc) ? 1 : -1 }
        }
        return 0;
      });
    }
    return result;
  }

  const getLocalOrderBy = () => {
    const ob = orderBy.find(x => x.active);
    return (ob && ob.type !== `default`) ? `&order_by=${(!ob.asc) ? `-` : ``}${ob.type}` : ``;
  }

  const getListOrderBy = () => {
    return orderBy.reduce((base, x) => {
      base[x.type] = { label: x.label, active: x.active, asc: x.asc, onClick: x.onClick };
      return base;
    }, []);
  }

  return { listOrderBy: getListOrderBy(), getOrderByFormatted, getLocalOrderBy, sortLocalData };
};

export default useOrderBy;
